import { useState, useEffect } from "react"

function useMediaQuery(query) {
	const [matches, setMatches] = useState(false)

	useEffect(() => {
		const mediaQuery = window.matchMedia(query)
		const handleChange = () => setMatches(mediaQuery.matches)

		setMatches(mediaQuery.matches)

		mediaQuery.addEventListener("change", handleChange)

		return () => {
			mediaQuery.removeEventListener("change", handleChange)
		}
	}, [query])

	return matches
}

export default useMediaQuery
